import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalWrapperModule } from 'src/app/UI-Lib/Modal-Wrapper/modalWrapper.module';
import { PaymentApprovalActionModalComponent } from './paymentApprovalActionModal.component';
import { PaymentApprovalCommentModalComponent } from './paymentApprovalCommentModal.component';
import { PaymentApprovalResultModalComponent } from './paymentApprovalResultModal.component';

@NgModule({
    imports: [CommonModule, FormsModule, ModalWrapperModule],
    declarations: [
        PaymentApprovalActionModalComponent,
        PaymentApprovalCommentModalComponent,
        PaymentApprovalResultModalComponent,
    ],
    exports: [
        PaymentApprovalActionModalComponent,
        PaymentApprovalCommentModalComponent,
        PaymentApprovalResultModalComponent,
    ],
})
export class PaymentApprovalModule {}
